import * as React from "react";
import { AuthorizationInfo } from "../patient-portal/AuthorizationInfo";
import AuthorizationInformationItemsList from "./AuthorizationInformationItemsList";

export default function PatientAuthorizedMembersPanel({
  authorizationInformation,
  title,
}: {
  authorizationInformation?: AuthorizationInfo;
  title: string;
}) {
  return (
    <div className="panel patient-authorized-members-panel">
      <div className="panel-title h-flex space-between no-wrap">
        <div>{title}</div>
      </div>
      {authorizationInformation ? (
        authorizationInformation.hasAuthorization ? (
          <AuthorizationInformationItemsList authorizationInfo={authorizationInformation} />
        ) : (
          <div className="centered">
            <span className="no-information-message">
              {i18n["Page.Patient.FullDetails.AuthorizationInformation.NoAuthorizations"]}
            </span>
          </div>
        )
      ) : (
        <div className="centered">
          <span className="no-information-message">
            {i18n["Page.Patient.FullDetails.Information.NotFilled"]}
          </span>
        </div>
      )}
    </div>
  );
}
